import React from "react";

import { useSidebar } from "./hooks/useSidebar";

interface SidebarContentProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * SidebarContent - Scrollable content area of the sidebar
 *
 * @param className - Additional CSS classes
 * @param children - Content items (typically SidebarGroup components)
 */
export function SidebarContent({
  className = "",
  children,
}: SidebarContentProps) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <div
      className={`
        flex flex-col flex-1 overflow-y-auto overflow-x-hidden
        py-sm gap-xs transition-[padding] duration-200
        ${isCollapsed ? "px-xs" : "px-md"}
        ${className}
      `.trim()}
      data-state={state}
    >
      {children}
    </div>
  );
}
